import { httpsCallable } from 'firebase/functions'
import { functions } from '@/config/firebase'
import { ChatMessage } from '@/types/chat'

interface ChatMessageResponse {
  id: string
  chatId: string
  senderId: string
  content: string
  createdAt: string | null
  isRead: boolean
}

const toChatMessage = (message: ChatMessageResponse): ChatMessage => {
  return {
    id: message.id,
    chatId: message.chatId,
    senderId: message.senderId,
    content: message.content,
    createdAt: message.createdAt ? new Date(message.createdAt) : new Date(),
    isRead: message.isRead,
  }
}

export interface GetOrCreateChatResponse {
  chatId: string
  roomId: string
  /** チャット両者の Firebase UID。Firestoreのアクセス制御に使用する。 */
  participantUids: string[]
}

export const getOrCreateChat = async (roomId: string, partnerUserId: string): Promise<GetOrCreateChatResponse> => {
  try {
    const getOrCreateChatFunction = httpsCallable(functions, 'get_or_create_chat')
    const result = await getOrCreateChatFunction({ roomId, partnerUserId })
    return result.data as GetOrCreateChatResponse
  } catch (error) {
    console.error('[getOrCreateChat] Error:', error)
    throw error
  }
}

export const getChatMessages = async (chatId: string): Promise<ChatMessage[]> => {
  try {
    const getChatMessagesFunction = httpsCallable(functions, 'get_chat_messages')
    const result = await getChatMessagesFunction({ chatId })
    const data = result.data as { messages: ChatMessageResponse[] }
    return data.messages.map(toChatMessage)
  } catch (error) {
    console.error('[getChatMessages] Error:', error)
    throw error
  }
}

export const markChatAsRead = async (chatId: string): Promise<void> => {
  try {
    const fn = httpsCallable(functions, 'mark_chat_as_read')
    await fn({ chatId })
  } catch (error) {
    console.error('[markChatAsRead] Error:', error)
    throw error
  }
}

export const sendChatMessage = async (chatId: string, content: string): Promise<ChatMessage> => {
  try {
    const sendChatMessageFunction = httpsCallable(functions, 'send_chat_message')
    const result = await sendChatMessageFunction({ chatId, content })
    const data = result.data as { message: ChatMessageResponse }
    return toChatMessage(data.message)
  } catch (error) {
    console.error('[sendChatMessage] Error:', error)
    throw error
  }
}
